export default __webpack_public_path__ + "static/media/tag_green.306cfe7c.svg";